import { render, staticRenderFns } from "./AllocationProviders.vue?vue&type=template&id=0ac9e1dc"
import script from "./AllocationProviders.vue?vue&type=script&lang=js"
export * from "./AllocationProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports